module.exports = __webpack_public_path__ + "img/the-sword-of-kaigen.315813d9.png";